/**
 * Accounting reference types the API recognises. The column behind it is an
 * unconstrained string, so a value outside this list can reach the client and
 * must not invalidate the page it arrived in.
 */
export const ACCOUNTING_REFERENCE_TYPES = [
  'cost_center',
  'profit_center',
] as const;
